export const safeDateString = (value) => {
    if (isNaN(Date.parse(value)))
        return 'N/A';
    return new Date(value).toLocaleDateString('en-US', {
        timeZone: 'UTC',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
};
//# sourceMappingURL=safe-date-string.js.map